import moment from "moment";

const getDateLabel = (dateInput) => {
    const messageDate = moment(dateInput).startOf('day');

    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');

    let dateLabel;
    if (messageDate.isSame(today)) {
        dateLabel = 'Today';
    } else if (messageDate.isSame(yesterday)) {
        dateLabel = 'Yesterday';
    } else if (messageDate.isSame(today, 'week')) {
        dateLabel = messageDate.format('dddd'); // Day of the week, e.g., Monday, Tuesday
    } else if (messageDate.isSame(today, 'year')) {
        dateLabel = messageDate.format('ddd, D MMM'); // e.g., Fri, 25 Oct
    } else {
        dateLabel = messageDate.format('D MMM YYYY'); // Full date, e.g., 14 Mar 2002
    }

    return dateLabel
}

export const useMessageGrouping = (messages) => {
    const groupedMessages = [];
    let lastDate = "";

    if (!messages?.length) return { groupedMessages };

    [...messages].forEach((msg, idx, arr) => {
        const lastIndex = arr.length - 1
        const dateSource = msg.localCreatedAt || msg.createdAt;
        const messageDate = moment(dateSource).startOf('day');

        if (!lastDate || !messageDate.isSame(lastDate)) {
            if (lastDate && (!messageDate.isSame(lastDate) || (idx === lastIndex))) {
                const dateLabel = getDateLabel(lastDate);
                groupedMessages.push({ type: "date", value: dateLabel });
            }
            lastDate = messageDate;
        }

        groupedMessages.push({ type: "message", value: msg });

        if ((idx === lastIndex)) {
            const dateLabel = getDateLabel(lastDate);
            groupedMessages.push({ type: "date", value: dateLabel });
        }

    });

    return { groupedMessages };
};